import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { walletRetrieve } from "../../Services/MainService";
import {
  customerPayingLaterOrders,
  settleOutstanding,
} from "../../Services/OrderService";
import { HistoryOrderCard } from "../Components/HistoryOrderCard";

const DNPLOrders = () => {
  const [orders, setOrders] = React.useState([]);
  const [ordersLoading, setOrdersLoading] = React.useState(false);
  const [outstandingBalance, setOutstandingBalance] = React.useState(0);
  const [isOpen, setIsOpen] = React.useState(false);
  const [availableBalance, setAvailableBalance] = React.useState(0);
  const [walletLoading, setWalletLoading] = React.useState(false);
  const [refresh, setRefresh] = React.useState(Date.now());
  const [selectedOrders, setSelectedOrders] = React.useState([]);
  const [settlementLoading, setSettlementLoading] = React.useState(false);
  const navigate = useNavigate();
  React.useEffect(() => {
    fetchOrders();
    fetchWallet();
    setSelectedOrders([]);
  }, [refresh]);
  const fetchOrders = () => {
    setOrdersLoading(true);
    customerPayingLaterOrders().then(
      (res) => {
        setOrders(res.data);
        let balance = 0;
        res.data.forEach((order) => {
          balance -= order.order_amount;
        });
        setOutstandingBalance(balance);
        setOrdersLoading(false);
      },
      (er) => {
        console.warn(er);
        toast.error("Something went wrong while fetching orders.");
        setOrdersLoading(false);
      }
    );
  };
  const fetchWallet = () => {
    setWalletLoading(true);
    walletRetrieve().then(
      (res) => {
        let balance = 0;
        res.data.forEach((x) => {
          balance += x.balance;
        });
        setAvailableBalance(balance);
        setWalletLoading(false);
      },
      (er) => {
        console.warn(er);
        toast.error("Something went wrong while fetching wallet.");
      }
    );
  };
  const handleCheck = (id) => {
    setSelectedOrders((ids) => {
      const arr = [...ids];
      const i = arr.indexOf(id);
      if (~i) {
        arr.splice(i, 1);
      } else arr.push(id);
      return arr;
    });
  };
  const handleSettle = () => {
    if (availableBalance >= outstandingBalance && !settlementLoading) {
      setSettlementLoading(true);
      settleOutstanding(selectedOrders).then(
        (res) => {
          toast.success(res.message);
          setRefresh(Date.now());
          setIsOpen(false);
          setSettlementLoading(false);
        },
        (er) => {
          console.warn(er);
          toast.error(er.errors);
          setSettlementLoading(false);
        }
      );
    }
  };
  return (
    <>
      <div className="container">
        <div
          className="row flex-column align-items-center py-3"
          style={{ minHeight: "100vh" }}
        >
          {ordersLoading ? (
            <div className="col-12 text-center">
              <Spinner variant="primary" />
            </div>
          ) : orders.length > 0 ? (
            <div className="col-lg-6 col-md-9 col-12 py-1">
              <div
                className="app-bg-dark py-4 px-3 mb-3"
                style={{ borderRadius: "18px" }}
              >
                <small className="" style={{ color: "#E3E3E3" }}>
                  Outstanding balance
                </small>
                <h3 className="text-white fw-bold mb-0">
                  Rs. {outstandingBalance.toLocaleString()}
                </h3>
              </div>
              <div className="text-center">
                <button
                  className="service-btn next"
                  onClick={() => setIsOpen(true)}
                >
                  Settle my Credit
                </button>
              </div>
              <hr style={{ borderStyle: "dashed" }} />
              {orders.map((x) => (
                <HistoryOrderCard order={x} navigate={navigate} />
              ))}
            </div>
          ) : (
            <div className="col-12 text-center">
              <h4 className="text-muted text-uppercase">No Records Found!</h4>
            </div>
          )}
        </div>
      </div>
      <Modal
        show={isOpen}
        onHide={() => {
          setIsOpen(false);
          setSelectedOrders([]);
        }}
        backdrop="static"
        size="lg"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>Select Orders to Settle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="app-bg-dark py-4 px-3 mb-3 d-flex justify-content-between align-items-center flex-wrap"
            style={{ borderRadius: "18px" }}
          >
            {walletLoading ? (
              <span className="spinner-border text-white"></span>
            ) : (
              <div>
                <small className="" style={{ color: "#E3E3E3" }}>
                  Available Balance
                </small>
                <h3 className="text-white fw-bold mb-0">
                  Rs. {availableBalance.toLocaleString()}
                </h3>
              </div>
            )}
            <div>
              <small className="" style={{ color: "#E3E3E3" }}>
                Outstanding balance
              </small>
              <h3 className="text-white fw-bold mb-0">
                Rs. {outstandingBalance.toLocaleString()}
              </h3>
            </div>
          </div>
          <div
            style={{
              height: "calc(100vh - 290px)",
              overflowY: "auto",
              marginBottom: "5px",
            }}
          >
            {orders.map((order) => (
              <>
                <label className="d-flex align-items-center justify-content-between py-2 cour">
                  <div className="d-flex flex-column">
                    <span>Order ID: {order.id}</span>
                    <small className="text-muted">
                      Amount: {order.order_amount}
                    </small>
                  </div>
                  <div className="form-check mb-0">
                    <input
                      id={`dnpl-order-${order.id}`}
                      className="form-check-input"
                      type="checkbox"
                      checked={selectedOrders.includes(order.id)}
                      onChange={() => handleCheck(order.id)}
                    />
                  </div>
                </label>
              </>
            ))}
          </div>
          <button
            className="service-btn next w-100"
            disabled={
              availableBalance < outstandingBalance || settlementLoading
            }
            onClick={handleSettle}
          >
            {settlementLoading ? (
              <span className="spinner-border spinner-border-sm text-dark"></span>
            ) : (
              "Settle Selected Orders"
            )}
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DNPLOrders;
